export default __webpack_public_path__ + "static/new-relic-screen-ddccc72f6600358d6a65ed9cdde106c9.jpg";